<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* background-image: url("../assets/login-bg.png"); */
  /* background-size: cover; */
}
.logo {
  width: 100%;
}
.logo2 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logo_image {
  width: 175px;
  height: 54px;
  margin: 47px 0px 0px 53px;
}
.logo_image2 {
  width: 100px;
  height: 100px;
}
.logo-form {
  width: 408px;
  height: 800px;
  /* background-color: red; */
  margin: 0 auto;
  text-align: center;
}
.logo-form-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #3d3d3d;
  margin: 16px 0px 24px 0px;
}
::v-deep .el-input__inner {
  height: 54px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 40px;
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 16px;
}
.person_logo {
  width: 24px;
  height: 24px;
  margin: 16px 16px 0px 8px;
}
.verification_img {
  width: 127px;
  height: 46px;
  margin-top: 4px;
}
.df1 {
  display: flex;
  justify-content: end;
}
.mt16 {
  margin-top: 16px;
}
::v-deep .el-button {
  width: 100%;
  border-radius: 35px;
  background: #2e7516;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  margin-top: 18px;
}

.read {
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 16px 0px 34px 0px;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  margin: 0px 8px;
}
.login-line {
  display: flex;
}
.line1 {
  width: 161px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
}
.line2 {
  flex: 1;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  margin-top: -8px;
}
.dialog-footer-button {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  background: #ffffff;
  line-height: 5px;
  font-size: 14px;
}
.dialog-footer-button2 {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: #ffffff;
  background: #2e7516;
  line-height: 5px;
  font-size: 14px;
}

.header h1 {
  width: 100%;
  text-align: center;
  font-size: 24px;
}
.content {
  padding: 0px 20px 20px 20px;
}
.pt8 {
  padding-top: 8px;
}

.fw700 {
  font-weight: 700;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
ul {
  margin-left: 40px;
}
.p16 {
  padding: 16px 0px;
}
.ml22 {
  margin-left: 22px;
}
.ml28 {
  margin-left: 28px;
}
.mt24 {
  margin-top: 24px;
}

</style>
<template>
  <div class="app">
    <div class="header">
      <h1>XRION Privacy Policy</h1>
    </div>
    <div class="content">
      <p class="pt8 fw700">Release Date: August 1, 2025</p>
      <p class="pt8 fw700">Effective Date: August 1, 2025</p>

      <div class="fw700 pt8">
        <div>
          XRION ("we" or "XRION") recognizes the importance of your personal
          information and will implement strict security measures to protect it
          in compliance with applicable laws and regulations. This Privacy
          Policy explains how we collect, use, store, and safeguard your
          personal information. Please read and understand this policy carefully
          before using our services.
        </div>
      </div>

      <div class="section-title">1. Information We Collect</div>
      <p class="ml22">1.1 Information You Provide</p>
      <ul>
        <li>
          Registration details: Mobile number, email address, nickname, etc.
        </li>
        <li>
          Content uploaded when using services: Translated text, voice files,
          documents, etc.
        </li>
        <li>
          Payment information: If you choose paid services, relevant payment
          account details are required.
        </li>
      </ul>
      <p class="ml22">1.2 Automatically Collected Information</p>
      <ul>
        <li>
          Device information: Device model, operating system version, unique
          device identifier, etc.
        </li>
        <li>Log data: IP address, access time, usage frequency, etc.</li>
        <li>
          Location information: Approximate location (based on IP address).
        </li>
      </ul>
      <p class="ml22">1.3 Third-Party Information</p>
      <ul>
        <li>
          Basic profile data obtained when logging in via third-party accounts
          (e.g., WeChat, Google).
        </li>
      </ul>

      <div class="section-title">2. How We Use Your Information</div>
      <p class="ml22">2.1 Core Functionalities</p>
      <ul>
        <li>Providing text, voice, and document translation services.</li>
        <li>Account registration, login, and verification.</li>
        <li>Processing paid service orders.</li>
      </ul>
      <p class="ml22">2.2 Service Optimization</p>
      <ul>
        <li>Improving translation algorithm quality.</li>
        <li>Enhancing user experience.</li>
        <li>Conducting data analysis.</li>
      </ul>
      <p class="ml22">2.3 Security Assurance</p>
      <ul>
        <li>Detecting and preventing fraudulent activities.</li>
        <li>Ensuring system security and stability.</li>
      </ul>

      <div class="section-title">3. Information Sharing and Disclosure</div>
      <p class="ml22">3.1 Strict Sharing Limitations</p>
      <p class="ml28">
        We do not share your personal information with third parties unless:
      </p>

      <ul>
        <li>Explicit authorization is obtained from you.</li>
        <li>
          Necessary for providing specific services (e.g., payment processing).
        </li>
        <li>Required by laws, regulations, or judicial authorities.</li>
      </ul>

      <p class="ml22">3.2 Third-Party Service Providers</p>
      <p class="ml28">
        To ensure stable operation and functionality, we may integrate
        third-party Software Development Kits (SDKs). 
      </p>
      <p class="ml28">
        Types of Personal
        Information Processed by Third-Party SDKs: Device identifiers (including
        IMEI, IDFA, Android ID, GAID, MAC, OAID, IMSI, MEID, UAID), device
        hardware information (device model, screen resolution, manufacturer,
        product name), operating system details (version, name, language),
        network information (connection type, carrier, base station data, IP
        address, Wi-Fi details, SSID, BSSID), push notification logs, precise
        location data, and software list information (installed and running
        applications).
      </p>
      <p class="ml28">Currently integrated third-party SDKs are as follows:</p>
      <p class="ml28">SDK Name: ali-sms</p>
      <p class="ml28">Purpose of Collection: Sending SMS verification codes to validate user identity.</p>
      <p class="ml28">Types of Personal Information Collected: User mobile phone number</p>
      <p class="ml28">SDK Privacy Policy Address:<a href="https://github.com/aliyun/alibaba-cloud-sdk-go" target="_blank">https://github.com/aliyun/alibaba-cloud-sdk-go </a></p>
      
      <p class="ml28 mt24">SDK Name: stripe</p>
      <p class="ml28">Purpose of Collection: Enabling users to make payments via stripe</p>
      <p class="ml28">Types of Personal Information Collected: Mobile phone number, email, bank card, verification information </p>
      <p class="ml28">SDK Privacy Policy Address: <a href="https://github.com/stripe/stripe-go" target="_blank">https://github.com/stripe/stripe-go</a></p>
      

      <div class="section-title">4. Data Storage and Protection</div>
      <p class="ml22">4.1 Retention Period</p>
      <ul>
        <li> Translation content: Processed in real-time; original content is not stored.</li>
        <li>Account information: Retained until account deletion.</li>
        <li>Log data: Up to 6 months.</li>
      </ul>
      <p class="ml22">4.2 Security Measures</p>
      <ul>
        <li>SSL/TLS encrypted transmission.</li>
        <li>Encrypted data storage.</li>
        <li>Strict access controls.</li>
      </ul>

      <div class="section-title">5. Your Rights</div>
      <p class="ml22">5.1 Access and Correction</p>
      <p class="ml28">You may view and modify personal information through account settings.</p>
      <p class="ml22">5.2 Right to Deletion</p>
      <ul>
        <li>Delete individual translation records.</li>
        <li>Delete your account (contact customer support).</li>
      </ul>
      <p class="ml22">5.3 Withdrawal of Consent</p>
      <p class="ml28">You may disable permissions (e.g., location) via device settings.</p>

      <div class="section-title">6. Protection of Minors</div>
      <p class="ml22">6.1 We do not knowingly collect personal information from children under 14.</p>
      <p class="ml22">6.2 Users aged 14–18 must obtain parental/guardian consent before using our services.</p>

      <div class="section-title">7. Policy Updates</div>
      <p class="ml22">We may update this policy periodically. Significant changes will be notified prominently.</p>

      <div class="section-title">8. Contact Us</div>
      <p>For questions regarding this policy, email: <a href="">admin@xrion.ai </a></p>
      <p class="fw700 p16">
        Note: This Privacy Policy is an integral part of XRION’s Terms of Service. Please review it carefully before using our services.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPageEn",
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>
